<jsdaddy-show-cases-list
    title="Show Cases"
    subtitle="SOFTWARE DEVELOPMENT"
    [isSubtitleMoreThanText]="screenSizeMobile >= (innerWidth() || 0)"
    forMainPage
    [showCases]="showCases() || []" />
